module.exports = __webpack_public_path__ + "img/modernwide-black-frame-right-shadowed.ccd16ed7.png";